
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({
  components: {},
  filters,
})
export default class NewsItem1 extends Vue {
  @Prop({ default: null })
  private news!: any;
}
